/**
 * Utility functions for DataFast tracking
 */

/**
 * Helper function to read a cookie by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
export function getCookie(name) {
  if (typeof document === 'undefined') return null
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop().split(';').shift()
  }
  return null
}

/**
 * Get DataFast tracking parameters from cookies
 * @returns {Object} - Object with datafast_visitor_id and datafast_session_id
 */
export function getDataFastTrackingParams() {
  const visitorId = getCookie('datafast_visitor_id')
  const sessionId = getCookie('datafast_session_id')
  
  const params = {}
  if (visitorId) {
    params.datafast_visitor_id = visitorId
  }
  if (sessionId) {
    params.datafast_session_id = sessionId
  }
  
  return params
}

/**
 * Append DataFast tracking parameters to a URL
 * @param {string} url - Base URL
 * @returns {string} - URL with DataFast tracking parameters appended
 */
export function appendDataFastParams(url) {
  const datafastParams = getDataFastTrackingParams()
  const urlObj = new URL(url)
  
  if (datafastParams.datafast_visitor_id) {
    urlObj.searchParams.append('datafast_visitor_id', datafastParams.datafast_visitor_id)
  }
  if (datafastParams.datafast_session_id) {
    urlObj.searchParams.append('datafast_session_id', datafastParams.datafast_session_id)
  }
  
  return urlObj.toString()
}

/**
 * Build a URL with DataFast tracking parameters from base params
 * @param {string} baseUrl - Base URL without query string
 * @param {Object} params - URL parameters object
 * @returns {string} - Complete URL with all parameters including DataFast tracking
 */
export function buildUrlWithDataFast(baseUrl, params = {}) {
  const urlParams = new URLSearchParams(params)
  
  // Add DataFast tracking parameters if available
  const datafastParams = getDataFastTrackingParams()
  if (datafastParams.datafast_visitor_id) {
    urlParams.append('datafast_visitor_id', datafastParams.datafast_visitor_id)
  }
  if (datafastParams.datafast_session_id) {
    urlParams.append('datafast_session_id', datafastParams.datafast_session_id)
  }
  
  return `${baseUrl}?${urlParams.toString()}`
}


